import { Reveal } from "./Reveal";
import { IMG } from "@/constants/bbAssets";

export const MeetTess = () => (
  <section id="tess" className="py-20 md:py-28 bg-tint/60 border-y border-deep/10">
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5">
        <Reveal>
          <div className="photo-frame relative max-w-sm mx-auto lg:mx-0 -rotate-2" data-testid="tess-photo-frame">
            <span className="tape -top-3 left-1/2 -translate-x-1/2 rotate-[3deg]" />
            <img
              src={IMG.trophy}
              alt="Tess holding an NCAA regional championship trophy"
              className="w-full aspect-[4/5] object-cover"
              data-testid="tess-photo"
            />
            <p className="pt-2.5 font-mono text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-deep/70">
              From championship courts to the sand
            </p>
            <span className="absolute -bottom-4 -right-3 md:-right-5 bg-sun text-deep font-mono text-[9px] md:text-[10px] uppercase tracking-[0.18em] px-4 py-2 rounded-full rotate-3 shadow-md">
              Founder + Lead Coach
            </span>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-deep/70 flex items-center gap-2">
            <span className="w-8 h-px bg-sun" /> The person behind the brand
          </p>
          <h2 className="mt-4 font-display uppercase text-deep leading-[0.95] text-[clamp(2.6rem,6vw,4.5rem)]">
            Meet Tess.
          </h2>
          <p className="mt-6 text-base md:text-lg text-deep-soft leading-relaxed">
            Tess grew up playing indoor volleyball and competed at a high level before transitioning
            into beach volleyball in college. After experiencing how different — and how fun — the
            beach game was, she wished she had been introduced to it sooner.
          </p>
          <p className="mt-5 text-base md:text-lg text-deep-soft leading-relaxed">
            She graduated from the University of Tampa, where she played indoor volleyball and
            transitioned to the beach. Her background as both a player and coach inspired Beach
            Break: a way to give younger indoor athletes an easier opportunity to discover beach
            volleyball.
          </p>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {["Player", "Coach", "Founder"].map((chip) => (
              <span
                key={chip}
                className="font-mono text-[10px] uppercase tracking-[0.2em] border border-deep/20 rounded-full px-4 py-2 text-deep"
              >
                {chip}
              </span>
            ))}
          </div>
          <p className="mt-8 font-serifit italic text-2xl text-deep">— Tess</p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default MeetTess;
